namespace TabAurous.Common {
    export interface OrderStatusAuthorizeForm {
        VoucherNo: Serenity.StringEditor;
        ECommOrderNo: Serenity.StringEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        CheckList: ECommerce.OrderManagementCheckListEditor;
        Remarks: Serenity.StringEditor;
    }

    export class OrderStatusAuthorizeForm extends Serenity.PrefixedContext {
        static formKey = 'Common.OrderStatusAuthorize';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderStatusAuthorizeForm.init)  {
                OrderStatusAuthorizeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;
                var w3 = ECommerce.OrderManagementCheckListEditor;

                Q.initFormType(OrderStatusAuthorizeForm, [
                    'VoucherNo', w0,
                    'ECommOrderNo', w0,
                    'Pieces', w1,
                    'Weight', w2,
                    'CheckList', w3,
                    'Remarks', w0
                ]);
            }
        }
    }
}
